import {
    type BlastForecastClientInterface,
    type GetBlastForecastRequest,
    type AdjustCampaignRequest,
    axiosCacheInterceptorRequestConfig,
} from './blastForecastClient.types';
import BaseClient, { type BaseClientConfig } from '../BaseClient';

export default class CorporateBlastForecastClient extends BaseClient implements BlastForecastClientInterface {
    constructor(private teamId: number, config: BaseClientConfig = {}) {
        super(config);
    }

    getBlastForecastSummary(params: GetBlastForecastRequest) {
        const url = `/api/v3/teams/${this.teamId}/blast-forecast/summary`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getBlastForecastCampaigns(params: GetBlastForecastRequest) {
        const url = `/api/v3/teams/${this.teamId}/blast-forecast/campaigns`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    adjustCampaign(campaignId: number, payload: AdjustCampaignRequest) {
        const url = `/api/v3/teams/${this.teamId}/blast-forecast/campaigns/${campaignId}`;
        return this.makeCoreApiRequest(url, 'patch', payload);
    }
}
